module.exports = __webpack_public_path__ + "static/media/Lamin Mansaray.d2b3ebb1.jpg";